// extracted by mini-css-extract-plugin
export default {"container":"team-mobile_container__2K4Gg","team":"team-mobile_team__1fCYI","row":"team-mobile_row__jDtnh","person":"team-mobile_person__s8mUu"};